import usa from './assets/us.webp'
import mexico from './assets/mexico.webp'
import italy from './assets/itly.webp'
import men from './assets/men.webp'
import sauthafrica from './assets/sa.webp'
import india from './assets/india.jpg'
import australiya from './assets/australiya.webp'
import korea from './assets/green.webp'
import us from './assets/girl.webp'
import spain from './assets/spain.webp'
import usa1 from './assets/usa.webp'

const data = [{
        background: `${india}`,
        rating: '5.0 (145)',
        city: 'India',
        caption: 'Plan The cultural Vacation',
        rent: 'From ₹2,565/'
    },{
        background: `${usa}`,
        rating: '4.33 (50)',
        city: 'United States',
        caption: 'Plan The Perfect NewYork Vacation',
        rent: 'From ₹1,565/'
    },{
        background: `${mexico}`,
        rating: '5.0 (45)',
        city: 'Mexico',
        caption: 'Live Tulum like a local',
        rent: 'From ₹836/'
    },{
        background: `${italy}`,
        rating: '5.0 (59)',
        city: 'Italy',
        caption: 'Plan a Venice venture with Giulia',
        rent: 'From ₹2,607/'
    },{
        background: `${men}`,
        rating: '3.5 (34)',
        city: 'United States',
        caption: 'Plan Trip to amazing Austing',
        rent: 'From ₹2,069/'
    },{
        background: `${sauthafrica}`,
        rating: '4.33 (64)',
        city: 'South Africa',
        caption: 'Plan perfect trip to sunny Miami',
        rent: 'From ₹1,718/'
    },{
        background: `${australiya}`,
        rating: '3.33 (47)',
        city: 'Australia',
        caption: 'Plan The Perfect Vacation',
        rent: 'From ₹1,565/'
    },{
        background: `${korea}`,
        rating: '4.33 (39)',
        city: 'South Korea',
        caption: 'Craft a Custom trip to korea with jay',
        rent: 'From ₹1,105/'
    },{
        background: `${us}`,
        rating: '4.33 (51)',
        city: 'United States',
        caption: 'Plan The Perfect NewYork Vacation',
        rent: 'From ₹1,565/'
    },{
        background: `${spain}`,
        rating: '4.5 (72)',
        city: 'spain',
        caption: 'Plan The Perfect barcelona Vacation',
        rent: 'From ₹3,465/'
    },{
        background: `${usa1}`,
        rating: '4.2 (34)',
        city: 'United States',
        caption: 'Plan The Perfect NewYork Vacation',
        rent: 'From ₹2,565/'
    }]
    export default data;